var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { injectIntl } from "@irati/utils/lang";
import authentication from "@irati/auth";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import History from "@irati/utils/history";
import { IconTypes } from "@irati/ui/src/Icon";
import IconWithNumber from "./IconWithNumber";
import Tooltip, { Tip } from "../shared/Tooltip";
var AddRewardIcon = /** @class */ (function (_super) {
    __extends(AddRewardIcon, _super);
    function AddRewardIcon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) {
            e.stopPropagation();
            e.preventDefault();
            var _a = _this.props, item = _a.item, type = _a.type;
            var canReward = authentication.apps("recognition.rewards.create");
            if (item.reward || !canReward) {
                return null;
            }
            History.push({ pathname: "/reward/add", state: { item: item, type: type } }, _this.context);
        };
        _this.getRewardText = function () {
            var _a = _this.props, item = _a.item, formatMessage = _a.formatMessage;
            var isRewardLimited = authentication.apps("recognition.rewards.viewLimited");
            if (item.rewardOrder) {
                var user = get(item.rewardOrder, "createdBy");
                if (!user) {
                    // don't know why it shouldn't be a user there, but we don't want to display fake infos
                    user = {
                        firstname: "",
                        lastname: ""
                    };
                }
                var name = firstnameLastname(user);
                if (isRewardLimited) {
                    return formatMessage({ id: "recognition.addReward.tooltip.partialView" }, { name: name });
                }
                return formatMessage({ id: "recognition.addReward.tooltip.fullView" }, { reward: get(item.rewardOrder, "reward.header") || "", name: name });
            }
            return formatMessage({ id: "recognition.addReward.tooltip.default" });
        };
        return _this;
    }
    AddRewardIcon.prototype.render = function () {
        var _a;
        var item = this.props.item;
        var isRewardDisabled = !!authentication.apps("recognition.recognition.rewardDisabled");
        var canReward = authentication.apps("recognition.rewards.create");
        if (isRewardDisabled || (!item.reward && !canReward))
            return null;
        var rewardActive = item.reward && (((_a = item === null || item === void 0 ? void 0 : item.createdBy) === null || _a === void 0 ? void 0 : _a.uuid) === authentication.user().uuid);
        return (React.createElement(Tooltip, { id: "addRewardTip", placement: "bottom", tip: React.createElement(Tip, { id: "addRewardToolTip" }, this.getRewardText()) },
            React.createElement(IconWithNumber, { icon: IconTypes.reward, active: rewardActive, onClick: this.handleClick })));
    };
    AddRewardIcon.contextTypes = {
        appPath: PropTypes.string.isRequired
    };
    return AddRewardIcon;
}(Component));
export default injectIntl(AddRewardIcon);
